export const hasLeadershipConstant = [
  { id: 0, name: "No" },
  { id: 1, name: "Yes" },
];
